export default __webpack_public_path__ + "media/assets/images/HippoLogo-14d5470c8f298203bda248e4c128db46.png";